var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zp-content"},[_c('img-upload',{ref:"checkDocumentUrl",staticClass:"file-upload",attrs:{"imageUrl":_vm.checkDocumentUrl,"isType":2,"limit":9,"title":"支持扩展名：doc .docx .pdf .xls .jpg"},on:{"downloadALink":_vm.downloadALink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }